// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b4179015","453":"9cd2f3fc","732":"ab765d55"}[chunkId] + ".chunk.js";
};